import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, useTheme } from "@mui/material";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DoneIcon from '@mui/icons-material/Done';
import { Cache } from "aws-amplify/utils";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    getAllJobItems,
    setJobItemRead,
    setSelectedJob,
    setShowProjects
} from "../../actions/job_actions";
import {
    setNotification,
    setNotificationAmount,
    setProjectedSkills,
    setSkillNotfiction
} from "../../actions/user_actions";
import _ from 'lodash';
import moment from 'moment';
function NotificationsCenter({ display, setDisplay }) {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector(state => state.user);
    const jobs = useSelector(state => state.jobs);
    const { skillValidationRequests = {}, projectedSkills = {} } = user;
    const { appliedJobs = [], favourited = [] } = jobs;
    const { requests = [] } = skillValidationRequests;
    const { unread = [] } = projectedSkills;

    const [fetchJobs, setFetchJobs] = useState(false);
    const [amount, setAmount] = useState(0);

    // Side effect to fetch jobs only once on mount
    useEffect(() => {
        if (!fetchJobs) {
            setFetchJobs(true);
            dispatch(getAllJobItems());
        }
    }, [fetchJobs, dispatch]);

    // Data transformation logic
    let jobList = [];
    if ((appliedJobs && appliedJobs.length > 0) || (favourited && favourited.length > 0)) {
        let combinedJobs = [...appliedJobs, ...favourited.filter(item => item.isInvited)];
        jobList = combinedJobs.flatMap((item) => {
            if (item.isProject) {
                if (item.added && !item.read) {
                    return [{
                        ...item,
                        notificationDate: moment(item.addedTimestamp).fromNow(),
                        savedTimestamp: item.addedTimestamp,
                        notificationTitle: "Added To Project",
                        color: "#93D69E",
                        notificationClick: () => {
                            Cache.setItem("sm_current_tab", 5);
                            navigate("/app/jobs");
                            setTimeout(() => {
                                dispatch(setNotification("applied"));
                            }, 100);
                            dispatch(setShowProjects(true));
                            dispatch(setSelectedJob(item.jobId, item.jobTitle, item.occupation, item.tier_one_category, false, true));
                        },
                        icon: <FiberManualRecordIcon sx={{ color: "#93D69E", fontSize: 10 }} />,
                        notificationDesc: `${item.jobTitle}: Click here to view the project.`
                    }];
                }
            } else if (!item.qual_name) {
                if (item.isInvited && !item.read) {
                    return [{
                        ...item,
                        notificationDate: moment(item.savedTimestamp).fromNow(),
                        notificationTitle: "Job Application Invite",
                        color: "#93D69E",
                        notificationClick: () => {
                            Cache.setItem("sm_current_tab", 4);
                            navigate("/app/jobs");
                            setTimeout(() => {
                                dispatch(setNotification("saved"));
                            }, 100);
                            dispatch(setSelectedJob(item.jobId, item.jobTitle, item.occupation, item.tier_one_category));
                        },
                        icon: <FiberManualRecordIcon sx={{ color: "#93D69E", fontSize: 10 }} />,
                        notificationDesc: `You have been invited to apply for: ${item.jobTitle}. Click here to view your saved job list and apply.`
                    }];
                } else if (typeof item.interview === "undefined" && !item.unsuccessful && !item.read) {
                    return [{
                        ...item,
                        notificationDate: moment(item.savedTimestamp).fromNow(),
                        notificationTitle: "Job Status",
                        color: "#93D69E",
                        notificationClick: () => {
                            Cache.setItem("sm_current_tab", 5);
                            navigate("app/jobs");
                            setTimeout(() => {
                                dispatch(setNotification("applied"));
                            }, 100);
                            dispatch(setSelectedJob(item.jobId, item.jobTitle, item.occupation, item.tier_one_category));
                        },
                        icon: <FiberManualRecordIcon sx={{ color: "#93D69E", fontSize: 10 }} />,
                        notificationDesc: `${item.jobTitle}. Click here to go to your applied list and change your status.`
                    }];
                } else if (typeof item.started === "undefined" && !item.unsuccessful && !item.read) {
                    return [{
                        ...item,
                        notificationDate: moment(item.savedTimestamp).fromNow(),
                        notificationTitle: "Job Status",
                        color: "#93D69E",
                        notificationClick: () => {
                            Cache.setItem("sm_current_tab", 5);
                            navigate("app/jobs");
                            setTimeout(() => {
                                dispatch(setNotification("applied"));
                            }, 100);
                            dispatch(setSelectedJob(item.jobId, item.jobTitle, item.occupation, item.tier_one_category));
                        },
                        icon: <FiberManualRecordIcon sx={{ color: "#93D69E", fontSize: 10 }} />,
                        notificationDesc: `${item.jobTitle}. Click here to go to your applied list and change your status.`
                    }];
                }
            } else {
                if (typeof item.interview === "undefined" && !item.unsuccessful && !item.read) {
                    return [{
                        ...item,
                        notificationDate: moment(item.savedTimestamp).fromNow(),
                        notificationTitle: "Training Status 1",
                        color: "#6A99FC",
                        icon: <FiberManualRecordIcon sx={{ color: "#6A99FC", fontSize: 10 }} />,
                        notificationClick: () => {
                            Cache.setItem("sm_current_tab", 5);
                            navigate("app/jobs");
                            setTimeout(() => {
                                dispatch(setNotification("applied"));
                            }, 100);
                            dispatch(setSelectedJob(item.qual_id, item.qual_name, item.occupation, item.tier_one_category, true));
                        },
                        notificationDesc: `${item.qual_name}. Click here to go to your applied list and change your status.`
                    }];
                } else if (typeof item.started === "undefined" && !item.unsuccessful && !item.read) {
                    return [{
                        ...item,
                        notificationDate: moment(item.savedTimestamp).fromNow(),
                        notificationTitle: "Training Status",
                        color: "#6A99FC",
                        icon: <FiberManualRecordIcon sx={{ color: "#6A99FC", fontSize: 10 }} />,
                        notificationClick: () => {
                            Cache.setItem("sm_current_tab", 5);
                            navigate("app/jobs");
                            setTimeout(() => {
                                dispatch(setNotification("applied"));
                            }, 100);
                            dispatch(setSelectedJob(item.qual_id, item.qual_name, item.occupation, item.tier_one_category, true));
                        },
                        notificationDesc: `${item.qual_name}. Click here to go to your applied list and change your status.`
                    }];
                }
            }
            return [];
        }).filter(Boolean); // Filter out any falsey values from flatMap
    }

    if (requests && requests.length > 0) {
        jobList = [...jobList, ...requests.map((item) => ({
            ...item,
            isValidation: true,
            savedTimestamp: item.requestedAt,
            notificationDate: moment(item.requestedAt).fromNow(),
            notificationTitle: "Skill Validation Request",
            color: "#93D69E",
            notificationClick: () => { navigate("profile"); },
            icon: <FiberManualRecordIcon sx={{ color: "#93D69E", fontSize: 10 }} />,
            notificationDesc: `Skill: ${item.skill}. Click here validate the skill.`
        }))];
    }
    if (unread && unread.length > 0) {
        jobList = [...jobList, ...unread.map((item) => ({
            ...item,
            isProjection: true,
            savedTimestamp: item.projectedAt,
            notificationDate: moment(item.projectedAt).fromNow(),
            notificationTitle: "Skill Evaluated",
            color: "#93D69E",
            notificationClick: () => { navigate("profile"); },
            icon: <FiberManualRecordIcon sx={{ color: "#93D69E", fontSize: 10 }} />,
            notificationDesc: `'${item.skill}' has been evaluated by ${item.projectedByName}. Click to view.`
        }))];
    }
    jobList = _.orderBy(jobList, "savedTimestamp", "desc");

    // Side effect to update the notification amount
    useEffect(() => {
        if (amount !== jobList.length) {
            dispatch(setNotificationAmount(jobList.length));
            setAmount(jobList.length);
        }
    }, [jobList.length, amount, dispatch]);

    if (jobList.length === 0) {
        let item = {};
        item.notificationTitle = "No actions pending";
        item.color = "#6A99FC";
        item.notificationClick = () => {};
        item.notificationDesc = `All caught up, way to go!`;
        item.icon = <DoneIcon sx={{ color: "#6A99FC", fontSize: 16 }} />;
        jobList.push(item);
    }

    return (
        <Box
            onClick={() => setDisplay(false)}
            sx={{
                top: 0,
                zIndex: 100000,
                position: "fixed",
                width: "100%",
                height: "100%",
                display: display ? "block" : "none",
            }}
        >
            <Box
                sx={{
                    display: display ? "block" : "none",
                    width: 320,
                    height: 300,
                    backgroundColor: "#ffffff",
                    position: "fixed",
                    zIndex: 1000,
                    right: 10,
                    top: 75,
                    boxShadow: "3px 3px 7px 0px",
                    overflowY: "auto",
                }}
            >
                <Typography variant="body1" sx={{ p: 3.125, pb: 0, m: 0 }}>
                    Notifications
                </Typography>
                {jobList.map((object, i) => (
                    <Grid
                        onClick={(e) => {
                            e.stopPropagation();
                            object.notificationClick();
                            if (object.isValidation) {
                                dispatch(setSkillNotfiction(object.skill));
                            } else if (object.isProjection) {
                                dispatch(setProjectedSkills(object.skill));
                            } else {
                                dispatch(setJobItemRead(object));
                            }
                            setDisplay(false);
                        }}
                        key={`${i}-notifcation`}
                        container
                        sx={{ p: 3.125, pb: 0, m: 0, cursor: "pointer" }}
                    >
                        <Grid item>
                            {object.icon}
                        </Grid>
                        <Grid item size={{xs:7}}>
                            <Typography variant="body2" sx={{ color: object.color, fontWeight: "bold", ml: 0.625 }}>
                                {object.notificationTitle}
                            </Typography>
                        </Grid>
                        <Grid item size={{ xs:4 }}>
                            <Typography variant="body2" sx={{ color: "#959596", textAlign: "right", fontSize: 10 }}>
                                {object.notificationDate}
                            </Typography>
                        </Grid>
                        <Grid size={{xs:12}}>
                            <Typography variant="body2" sx={{ mt: 1.25 }}>
                                {object.notificationDesc}
                            </Typography>
                        </Grid>
                    </Grid>
                ))}
            </Box>
        </Box>
    );
}

export default NotificationsCenter;